import { types } from './actions';

const initialState = {
  isModalOpen: false,
  originalAddress: null,
  suggestedAddresses: [],
};

export default (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.VALIDATE_ADDRESS_MODAL_CHOOSE_ADDRESS:
    case types.VALIDATE_ADDRESS_MODAL_CLOSE:
      return {
        ...state,
        isModalOpen: false,
      };
    case types.VALIDATE_ADDRESS_MODAL_OPEN:
      return {
        ...state,
        isModalOpen: true,
        suggestedAddresses: payload.suggestedAddresses,
      };
    case types.VALIDATE_ADDRESS_REQUEST:
      return {
        ...state,
        originalAddress: {
          address1: payload.address1,
          address2: payload.address2,
          city: payload.city,
          country: payload.country
            ? {
                abbr: payload.country,
              }
            : undefined,
          postalCode: payload.postalCode,
          state: payload.state
            ? {
                abbr: payload.state,
              }
            : undefined,
        },
      };
    default:
      return state;
  }
};

export const getScope = (state) => state.modules.common.modals.validateAddress;

export const getSuggestedAddresses = (state) =>
  getScope(state).suggestedAddresses;

export const getOriginalAddress = (state) => getScope(state).originalAddress;

export const isModalOpen = (state) => getScope(state).isModalOpen;
